import { DateTime } from "luxon";


export const getLSKey = (backend: string) => {
    return `${process.env.VUE_APP_SERVER}_tz-selector-offset_${backend}`;
}

export const setTimezoneToLS = (value: string, key: string) => {
    value && localStorage.setItem(key, value);
}

export const getTimezoneFromLS = (key: string) => {
    return localStorage.getItem(key) || (DateTime.local().offset / 60).toString();
}